<ng-container *ngIf="!performanceList">
    <div class="px-6 py-8">
        <span class="text-base bg-white border-1 border-slate-300 py-2 px-5 rounded-full">Loading</span>
    </div>
</ng-container>
<ng-container *ngIf="performanceList">
    <div class="px-6 py-2">
        <h3 class="text-lg font-semibold text-gray-700">Song Order</h3>
    </div>
    <div class="mt-2 border-t-1 border-slate-300">
        <ng-container *ngFor="let performance of performanceList; let i = index">
            <div class="flex flex-row h-22 border-b-1 border-r-1 border-slate-300">
                <div class="flex h-full w-15 items-center justify-center">
                    <span class="text-3xl font-medium">
                        {{ performance.sequenceNo }}
                    </span>
                </div>
                <div class="flex flex-col h-full grow justify-center">
                    <div>
                        <span class="text-lg font-medium">
                            {{ performance.performerName }} - {{ performance.songName }}
                        </span>
                    </div>
                    <div>
                        <span>{{ performance.representationCountryName }}</span>
                    </div>
                </div>
            </div>
            </ng-container>
    </div>
</ng-container>
